<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-else class="w-full">
      <vx-card>
        <vs-table
          :max-items="paginationItems[0]"
          pagination
          :data="FinancialActivityAccountList"
          search
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("accounting.label.financialactivitymapping") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Add Mapping' })"
                size="small"
                >{{ $t("accounting.label.definenewmapping") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("accounting.label.financialactivity") }}</vs-th>
            <vs-th>{{ $t("accounting.label.accountname") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="data" v-for="(accounts, index) in data">
              <vs-td>{{ accounts.financialActivityData.name }}</vs-td>
              <vs-td>{{ accounts.glAccountData.name }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    title="View"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="handleSelected1(accounts.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="EditIcon"
                    title="edit"
                    svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                    @click.stop="EditAccountMethod(accounts.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    title="delete"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deletePopup = true;
                      delId = accounts.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deletePopup"
      title="Financial Activity Mapping"
      @deletePressed="deleteMethod(delId)"
      @cancelPressed="deletePopup = false"
    >
    </delete-popup>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [10, 20, 30],
      delId: 0,
      deletePopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      FinancialActivityAccountList: (state) =>
        state.accounting.financialActivityAccounts,
    }),
  },
  methods: {
    async getFinancialActivityAccountsMethod() {
      this.loading = true;
      try {
        this.$store.dispatch("accounting/getFinancialActivityAccountsAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteMethod(id) {
      try {
        this.deletePopup = false;
        await this.$store.dispatch(
          "accounting/deletefinancialActivityMappingAction",
          id
        );
        this.getFinancialActivityAccountsMethod();
        this.$toasted.success("Deleted Successfully", {
          duration: 2000,
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    EditAccountMethod(id) {
      this.$router.push({ name: "Edit Mapping", params: { id: id } });
    },

    handleSelected1(id) {
      this.$router.push({
        name: "View Mapping",
        params: { id: id },
      });
    },
  },
  mounted() {
    this.getFinancialActivityAccountsMethod();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
